module.exports = __webpack_public_path__ + "static/media/bolt.e9bb5649.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/bolt.png
// module id = 486
// module chunks = 0